import SettingsCard from '../settings_card'
import AssignedCategories from './categories/assigned_categories'

const CategoriesCard = ({ asset, cycleID, langID }) => {
  const isAd = asset?.asset_type === 'ad'
  const isChildAsset = !!asset?.parent_asset_type
  const showCategories = !isAd && (!isChildAsset || asset?.asset_type === 'episode')
  const showAdAssignment = isAd && (asset?.is_warning_slate || asset?.is_preroll_ad)
  const showFeatured = asset?.asset_type === 'featured-content'

  if (!showCategories && !showAdAssignment && !showFeatured) return null

  return (
    <SettingsCard title='Categories'>
      <AssignedCategories
        availableCategories={asset.available_categories ?? []}
        availablePreroll={asset.available_preroll ?? []}
        availableWarningSlates={asset.available_warning_slates ?? []}
        categories={asset.categories ?? []}
        assetID={asset.id}
        assetType={asset.asset_type}
        cycleID={cycleID}
        langID={langID}
        issue={asset.asset_issues?.find((issue) => issue.validator_group === 'category')}
        isWarningSlate={asset?.is_warning_slate}
        isPrerollAd={asset?.is_preroll_ad}
      />
    </SettingsCard>
  )
}

export default CategoriesCard
